import { InfluencerProfileTags, InfluencerProfileTagsProps } from '../shared';

export type InfluencerInstagramProfileTagsProps = InfluencerProfileTagsProps;

export const InfluencerInstagramProfileTags = (props: InfluencerInstagramProfileTagsProps) => (
  <InfluencerProfileTags {...props} />
);
